import React from "react";
import { Loader } from "@design-system/Loader/Loader";
import { OverPageCTA } from "@design-system/Banner/OverPageCTA";
import styles from "./ReportDataProcessingBanner.module.scss";

export const ReportDataProcessingBanner: React.FC = () => (
    <OverPageCTA
        title={
            <span className={styles.title}>
                <Loader inline />
                Report data is still processing
            </span>
        }
        subtitle="Your migrated journal entries are being converted. Figures will update automatically once it's done."
    />
);
